import { mapState } from "vuex";

const WidgetMixin = {
  props: {
    metricWidget: {
      type: Object,
      required: true,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    layoutMode: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goFullScreen(widget) {
      this.$emit('fullscreen', widget)
    }
  },  
  computed: {
    ...mapState({
      metrics: (state) => state.metrics.all,
      caseTypes: (state) => state.caseTypes.all
    }),    
    widgetHeight() {
      return `widget--content-${this.metricWidget.height}y`;
    },
    chartData() {
      return this.metricWidget.chartData
    },    
    isTimebased() {
      const baseMetric = this.metrics.find(m => m.id === this.metricWidget.metric.baseMetricId)
      return (baseMetric && baseMetric.type==='State Transition') 
    },
    currencySymbol() {
      const baseMetric = this.metrics.find(m => m.id === this.metricWidget.metric.baseMetricId)
      if (baseMetric && baseMetric.type==='Case Property') {
        const caseType = this.caseTypes.find(ct => ct.id === baseMetric.caseTypeId)
        if (caseType && caseType.currentSchema) {
          const fieldsets = caseType.currentSchema.fieldsets
          for (const fieldset of fieldsets) {
            for (const field of fieldset.fields) {
              if (field.name===baseMetric.propertyName) {
                return field.symbol
              }
            }
          } 
        }
      }
    },
    widgetStyle() {
      switch (this.metricWidget.style) {
        case "outline":
          return "widget-style-outline"
        case "white":
          return "widget-style-white"
        case "blue":
          return "widget-style-blue"      
        default:
          return "widget-style-outline";
      }
    }
  }
}

export default WidgetMixin